import {
    DataQuery
  } from "cartovista";
import ResultItem from "cartovistaExtend/panels/Results/ResultItem";
import FindRoutesFeatureItem from "cartovistaExtend/panels/na/FindRoutesFeatureItem";

export default class FindRoutesResultItem extends ResultItem {
        constructor(resultList, features, name, directions, stops) {
          super(resultList, features, name);
          this.directions = this._addFeatureItems(directions);
          this.stops = stops;
        };
  
        _setVisibility(bool){
          super._setVisibility(bool);
          _.forEach(this.stops, function(stop) {
              stop.visible = bool;
          });
          _.forEach(this.directions, function(direction) {
              direction.visible = bool;
          });
        };
  
        _getFeatureName(){
          var name;
          new DataQuery([this._resultList.layer.featureNameDataColumn], [this.featuresItems[0].feature.id])
                        .execute(function(result) {
                            name = result.values[this._resultList.layer.featureNameDataColumn.dataTable.id][this._resultList.layer.featureNameDataColumn.id][0];
          }, this);
          return name;
        };
  
      _addFeatureItems(features) {
          return _.map(features, function(feature) {
              return new FindRoutesFeatureItem(this, feature, false);
          }.bind(this));
      };
  
      _generateResultItemUI(containerId) {
          this._$resultListRow = super._generateResultItemUI(containerId);
          this._$resultListRow.find(".list-group").html(_.invokeMap(this.directions, "_generateFeatureItemRow"));
          return this._$resultListRow;
      };
  }